import React from 'react';
import { Monitoring } from '@components/monitoring';

const Monitoraggio = (props) => {
  return (
    <div id='monitoraggio' className='megaContent'>
      <div className='container-fluid'>
        <Monitoring {...props} />
      </div>
    </div>
  );
};

export default Monitoraggio;
